import * as whatIfTypes from './whatIfTypes';

const initialState = {
  employees: { 0: {} },
  lookups: {
    levelsList: ['Consultant', 'Senior Manager', 'Director'],
    maritalStatusList: ['Single', 'Married'],
    policyList: {
      'Long Term Assignment': 'long',
      'Short Term Assignment': 'short',
    },
    currencies: {
      NONE: 'N/A',
      AFGHANISTAN: 'AFN',
      ALGERIA: 'DZD',
      ANGOLA: 'AOA',
      ARGENTINA: 'ARS',
      ARUBA: 'AWG',
      AUSTRALIA: 'AUD',
      AUSTRIA: 'EUR',
      AZERBAIJAN: 'AZN',
      BAHRAIN: 'BHD',
      BANGLADESH: 'BDT',
      BELGIUM: 'EUR',
      BERMUDA: 'BMD',
      BOTSWANA: 'BWP',
      BRAZIL: 'BRL',
      BRUNEI: 'BND',
      BULGARIA: 'BGN',
      CANADA: 'CAD',
      CHILE: 'CLP',
      CHINA: 'CNY',
      COLOMBIA: 'COP',
      'COSTA RICA': 'CRC',
      CROATIA: 'HRK',
      CYPRUS: 'EUR',
      'CZECH REPUBLIC': 'CZK',
      DENMARK: 'DKK',
      'DOMINICAN REPUBLIC': 'DOP',
      ECUADOR: 'USD',
      EGYPT: 'EGP',
      'EL SALVADOR': 'USD',
      ETHIOPIA: 'ETB',
      FINLAND: 'EUR',
      FRANCE: 'EUR',
      GEORGIA: 'GEL',
      GERMANY: 'EUR',
      GHANA: 'GHS',
      GREECE: 'EUR',
      GUATEMALA: 'GTQ',
      'HONG KONG': 'HKD',
      HUNGARY: 'HUF',
      INDIA: 'INR',
      INDONESIA: 'IDR',
      IRAQ: 'IQD',
      IRELAND: 'EUR',
      ISRAEL: 'ILS',
      ITALY: 'EUR',
      'IVORY COAST': 'XAF',
      JAMAICA: 'JMD',
      JAPAN: 'JPY',
      JORDAN: 'JOD',
      KAZAKHSTAN: 'KZT',
      KENYA: 'KES',
      KOREA: 'KRW',
      KUWAIT: 'KWD',
      LATVIA: 'EUR',
      LITHUANIA: 'EUR',
      LUXEMBOURG: 'EUR',
      MACAU: 'MOP',
      MALAYSIA: 'MYR',
      MAURITIUS: 'MUR',
      MEXICO: 'MXN',
      MOROCCO: 'MAD',
      NAMIBIA: 'NAD',
      NETHERLANDS: 'EUR',
      'NEW ZEALAND': 'NZD',
      NIGERIA: 'NGN',
      NORWAY: 'NOK',
      OMAN: 'OMR',
      PAKISTAN: 'PKR',
      PANAMA: 'PAB',
      PARAGUAY: 'PYG',
      PERU: 'PEN',
      PHILIPPINES: 'PHP',
      POLAND: 'PLN',
      PORTUGAL: 'EUR',
      'PUERTO RICO': 'USD',
      QATAR: 'QAR',
      ROMANIA: 'RON',
      RUSSIA: 'RUB',
      'SAUDI ARABIA': 'SAR',
      SERBIA: 'RSD',
      SINGAPORE: 'SGD',
      SLOVAKIA: 'EUR',
      SLOVENIA: 'EUR',
      'SOUTH AFRICA': 'ZAR',
      SPAIN: 'EUR',
      'SRI LANKA': 'LKR',
      SWEDEN: 'SEK',
      SWITZERLAND: 'CHF',
      TAIWAN: 'TWD',
      THAILAND: 'THB',
      'TRINIDAD AND TOBAGO': 'TTD',
      TUNISIA: 'TND',
      TURKEY: 'TRY',
      UGANDA: 'UGX',
      UKRAINE: 'UAH',
      'UNITED ARAB EMIRATES': 'AED',
      'UNITED KINGDOM': 'GBP',
      URUGUAY: 'UYU',
      USA: 'USD',
      VENEZUELA: 'VES',
      VIETNAM: 'VND',
    },
  },
  results: [],
  isLoadingCalculations: false,
  isDownloadingExcel: false,
  pageType: 'detail',
  detailIndex: null,
  colors: ['#2089DD', '#4EBEE8', '#9883D4', '#912D73', '#FC973D', '#93F0E6'],
  outputCurrency: { value: 'USD', label: 'USD' },
};

var addIndex = (function() {
  var index = 1;
  return function() {
    index += 1;
    return index;
  };
})();

export default (state = initialState, action) => {
  switch (action.type) {
    case whatIfTypes.ADD_EMPLOYEE:
      return {
        ...state,
        employees: {
          ...state.employees,
          [addIndex()]: {},
        },
      };
    case whatIfTypes.REMOVE_EMPLOYEES:
      return {
        ...state,
        employees: action.newEmployees,
      };
    case whatIfTypes.CLEAR_EMPLOYEES:
      return {
        ...state,
        employees: { 0: {} },
      };
    case whatIfTypes.SET_EMPLOYEE_VALUE:
      return {
        ...state,
        employees: {
          ...state.employees,
          [action.id]: {
            ...state.employees[action.id],
            [action.attr]: action.value,
          },
        },
      };
    case whatIfTypes.SET_OUTPUT_CURRENCY:
      return {
        ...state,
        outputCurrency: action.value,
      };
    case whatIfTypes.GET_CALCULATIONS_SUCCESS:
      return {
        ...state,
        results: action.data,
        maxCompensation: action.maxCompensation,
      };
    case whatIfTypes.SET_LOADING_CALCULATIONS:
      return {
        ...state,
        isLoadingCalculations: action.isLoading,
      };
    case whatIfTypes.SET_PAGETYPE:
      return {
        ...state,
        pageType: action.pageType,
      };
    case whatIfTypes.SELECT_RESULT:
      const selectedResults = [...state.results];
      selectedResults[action.index].selected = !selectedResults[action.index].selected;
      return {
        ...state,
        results: selectedResults,
      };
    case whatIfTypes.DELETE_SELECTED:
      const resultsAfterDeletion = state.results.filter(result => !result.selected);
      const newMax = Math.max(...resultsAfterDeletion.map(o => o.totalCompensation), 0);

      return {
        ...state,
        results: resultsAfterDeletion,
        maxCompensation: newMax,
      };
    case whatIfTypes.SET_CALCULATIONS_PARAMS:
      return {
        ...state,
        params: action.params,
      };
    case whatIfTypes.SET_LOADING_EXCEL_DOWNLOADING:
      return {
        ...state,
        isDownloadingExcel: action.isLoading,
      };
    case whatIfTypes.SET_DETAIL_INDEX:
      return {
        ...state,
        detailIndex: action.index,
      };
    case whatIfTypes.GET_COUNTRIES_DICTIONARY_SUCCESS:
      return {
        ...state,
        countriesDictionary: action.countriesDictionary,
      };
    case whatIfTypes.SET_EMPLOYEES_FROM_CSV:
      return {
        ...state,
        employees: action.employees,
      };

    default:
      return state;
  }
};
